import { defineTokens } from "@chakra-ui/react"

export const colors = defineTokens.colors({
  brand: {
    DEFAULT: {value: "#1818CF"},
  },
  accent: {
    DEFAULT: {value: "#1818CF"},
    red: { value: "#FF383C" },
    green: { value: "#2CA104" },
    secondary: {value: "#1818CF1A"},
  },
  text: {
    primary: {value: "#000000"},
    muted: {value: "#808080"},
    secondary: {value: "#61655E"},
    secondary_light: { value: "#BFBFBF" },
    gray_light: { value: "#9E9F9D" },
  },
  stroke: {
    DEFAULT: { value: "#CDCDCD" },
  }
})